import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { provide, reactive, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

const data = reactive({
  isMobile: null,
  isTablet: null
})

function mobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) || (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform))
}
function isTabletDetect() {
  return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(navigator.userAgent.toLowerCase())
}
data.isMobile = mobile()
data.isTablet = isTabletDetect()

window.onresize = () => {
  data.isMobile = mobile()
  data.isTablet = isTabletDetect()
}

onMounted(() => {
  document.title = 'Digital Card Solution Limited'
})

provide('isMobile', computed(() => data.isMobile))
provide('isTablet', computed(() => data.isTablet))

return (_ctx: any,_cache: any) => {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_NavBarMobile = _resolveComponent("NavBarMobile")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!data.isMobile || data.isTablet)
      ? (_openBlock(), _createBlock(_component_NavBar, { key: 0 }))
      : _createCommentVNode("", true),
    (data.isMobile && !data.isTablet)
      ? (_openBlock(), _createBlock(_component_NavBarMobile, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_RouterView, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade-fast",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _unref(route).fullPath
            }))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ]))
}
}

})